// @flow
import moment from 'moment'
import cloneDatetime from './cloneDatetime'
import { is12hFormat } from '.'

// Constants
export const HOUR_FORMAT = 'hh:mm A'
export const DATE_FORMAT_WITHOUT_TIME = 'MMMM DD'
export const DATE_FORMAT_WITH_TIME = `${DATE_FORMAT_WITHOUT_TIME}, ${HOUR_FORMAT}`
export const HOUR_FORMAT_24H = 'HH:mm'
export const DATE_FORMAT_WITH_TIME_24H = `${DATE_FORMAT_WITHOUT_TIME}, ${HOUR_FORMAT_24H}`

/**
 * Central date formatting function
 * @param  {string|moment} value
 * @param  {?bool} disableTime
 * @param  {?string} customFormat
 * @return {string}
 */
const formatDate = (
  value: mixed,
  disableTime: ?boolean,
  customFormat: ?string
): string => {
  const systemFormat = disableTime
    ? DATE_FORMAT_WITHOUT_TIME
    : is12hFormat()
    ? DATE_FORMAT_WITH_TIME
    : DATE_FORMAT_WITH_TIME_24H
  const finalFormat = customFormat || systemFormat

  // Important to reset locale because previous value could have previous
  // locale (and tha locale could be changed by the user)
  return cloneDatetime(value).locale(moment.locale()).format(finalFormat)
}

export default formatDate
